import CSVDataService from './csvDataService';
import { InfluencerListResponse } from '../types/influencer'; // Ensure this path is correct
import { FilterValues } from '../components/filters/FilterSection'; // Ensure this path is correct

/**
 * Service factory that returns the CSV data service
 */
const getDataService = () => {
  // console.log('✅ Using CSV DATA model (local file-based)');
  return CSVDataService;
};

// Export the configured service instance
export const DataService = getDataService();

// For convenience, also export the raw service
export { CSVDataService };

// Export a consistent DataService interface
export const DataServiceInterface = {
  getInfluencers: (filters: FilterValues, clientIp?: string): Promise<InfluencerListResponse> => 
    DataService.getInfluencers(filters, clientIp),
  saveUserInfo: (email: string, filters: FilterValues): Promise<{ success: boolean }> => 
    DataService.saveUserInfo(email, filters),
}; 